export default (width, height, position='relative') => {
  return styles => {
    let before = {
      display: 'block',
      content: '""',
      width: '100%',
      paddingTop: `${(height / width) * 100}%`
    }
    return Object.assign(styles, {
      position,
      ':before': before,
      '.content': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/aspectRatio.js